module.exports = __webpack_public_path__ + "media/images/hosted_by-b02270ffdba17aa9883b9844bd40eb80.svg";